import {
  handleSocketArsErrorEvent,
  handleSocketArsSuccessEvent,
} from './actions';

import { promptToaster } from '../../containers/App/actions';

/**
 * Consumed by Socket context to register listeners
 */
const applicationProfileSocketHandlers = (dispatch, socket) => {
  socket.on('ars.success', (message) => {
    const {
      file: { data: fileData, name: fileName },
      payload: { applicationId },
    } = message;
    const payload = {
      applicationId,
      fileData,
      fileName,
    };
    dispatch(handleSocketArsSuccessEvent(payload));
  });

  socket.on('ars.pending', (message) => {
    dispatch(
      promptToaster({
        type: 'info',
        message: message.text,
        title: 'Pending',
      }),
    );
  });

  socket.on('ars.error', (message) => {
    // Sanitize the error message to prevent React serialization issues
    const sanitizedMessage =
      typeof message === 'object' && message !== null
        ? {
            error:
              message.error ||
              message.text ||
              'An error occurred during application processing',
          }
        : { error: 'An error occurred during application processing' };
    dispatch(handleSocketArsErrorEvent(sanitizedMessage));
  });
};

export default applicationProfileSocketHandlers;
